export default {
  MY_HOME: `My Home`,
  MY_SCHEDULE: `My Schedule`,
  VIEW_YOUR_CURRENT_SCHEDULE: `View your current schedule`,
  VIEW_MY_SCHEDULE: `View my schedule`,
  MY_AVAILABILITY: `My Availability`,
  MANAGE_AVAILABILITY_FUTURE_SHIFTS: `Manage your availability for future shifts`,
  CREATE_AVAILABILITY: `Create availability`,
  CHANGE_AND_VIEW_MY_AVAILABILITY: `Manage my availabilities`,
  MY_ATTENDANCE: `My Attendance`,
  MANAGE_YOUR_REQUESTS: `Manage your absences, late, and early out requests`,
  CREATE_ATTENDANCE_REQUEST: `Create attendance`,
  VIEW_MY_ATTENDANCE_HISTORY: `View history`,
  MY_TIME_OFF: `My Time off`,
  REQUEST_VIEW_TIME_OFF: `Request and view time off`,
  CREATE_TIME_OFF_REQUEST: `Create time off`,
  VIEW_MY_TIME_OFF_REQUESTS: `View history`,
  MY_MESSAGES: `My Messages`,
  UNREAD_SHIFT_OFFER: `{{ count }} unread`,
  UNREAD_SHIFT_OFFER_other: `{{ count }} unread`,
  UNREAD_BULLETIN: `{{ count }} unread`,
  UNREAD_BULLETIN_other: `{{ count }} unread`,
  UNREAD_LOADING: `Loading...`,
  VIEW_BULLETINS_AND_OTHER_MESSAGES: `View bulletins and other relevant messages`,
  VIEW_MY_MESSAGES: `View my messages`,
  MY_SHIFT_OFFERS: `My Shift Offers`,
  VIEW_SHIFTS_CURRENTLY_OFFERED: `View shifts that are currently being offered`,
  VIEW_MY_OFFERS: `View my offers`,
  NO_APP_ACCESS: `Looks like you do not have access to any module here.`,
  NO_APP_ACCESS_MISTAKE: `If you believe this is a mistake, contact your manager.`,
  BULLETIN_ALERT: `You have {{unreadBulletinCount}} unread messages`,
  BULLETIN_ALERT_other: `You have {{unreadBulletinCount}} unread messages!`,
  help: {
    EMPLOYEEHOME: {
      TITLE: `Need help? Looking for something?`,
      DESCRIPTION: `The help centre is there to help you. In it you will find tutorials about how to use the application and more.`,
      LINK: `Access the Help Center`
    }
  },
  NEWBULLETIN_MODAL: {
    TITLE: `Unread messages`,
    SUMMARY: ``
  }
}
